module.exports = __webpack_public_path__ + "static/media/DesignTextEnrichesOptimized.e9196e06.webp";